import { Close } from '@mui/icons-material';
import { Backdrop, Box, IconButton, Typography } from '@mui/material';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { useLoggedInEmployeeId, useLoggedInUserRoles } from '~/components/Auth';
import { Roles } from '~/data/user';
import { hasOneOfRoles } from '~/services/Permissions';

import { ChatBotWidget } from './ChatBotWidget/component';
import { useChatBot } from './useChatBot';
import { useChatUI } from './useChatUI';
import { useSxStyles } from './useStyles';

export const ChatBotDialog = () => {
  const { isOpen, close } = useChatUI();

  const loggedInId = useLoggedInEmployeeId();
  const userRoles = useLoggedInUserRoles();
  const { resetToLanding } = useChatBot({ userId: loggedInId });

  const { t } = useTranslation();
  const sx = useSxStyles();

  useEffect(() => {
    if (!isOpen) {
      resetToLanding();
    }
  }, [isOpen, resetToLanding]);

  const isHrUser = hasOneOfRoles(userRoles, [
    Roles.HR_ADMIN,
    Roles.HR_ADMIN_LIMITED,
    Roles.HR_STAFF,
    Roles.HR_DEV,
  ]);

  if (!isOpen || !isHrUser) return null;

  const handleClose = () => {
    resetToLanding();
    close();
  };

  return (
    <>
      <Box sx={sx.root} onClick={(e) => e.stopPropagation()}>
        <Box sx={sx.container}>
          <Typography sx={{ fontWeight: 700, fontSize: 13, color: '#111' }}>
            {t('solAIris')}
          </Typography>

          <IconButton size="small" onClick={handleClose} title="Close">
            <Close fontSize="small" />
          </IconButton>
        </Box>

        <Box sx={{ flex: 1, minHeight: 0 }}>
          <ChatBotWidget hideTopHeader />
        </Box>
      </Box>
    </>
  );
};
